import { AloLogbookItem } from '../alo/AloLogbookItem';
import { ConsoleRow } from './ConsoleRow';

export class FleetUiState {
    
    public typeUiid:string
    public timelineIndex:number
    public rangeTimelineIndex:[number,number]
    public sciHoverData:any
    public navHoverData:any
    public mapStyles:any

    public canLogConsoleMsg:boolean
    public consoleMsgsLoading:boolean
    public consoleMsgs:Array<ConsoleRow>

          
    public _logBookLoaded :boolean  
    public logBookItems:Array<AloLogbookItem>
    
    public infosPanelVisible:boolean
    public missionMapVisibility:{[id:number]:boolean}    
    public missionDetailVisibility:{[id:number]:boolean}
    
    public selectedMissionPlanMissionId:number
        

    constructor({
                typeUiid="detail", //detail ou global
                timelineIndex = -1, 
                rangeTimelineIndex = [-1,-1] as [number,number],
                sciHoverData=null,
                navHoverData=null,
                mapStyles = {},
                canLogConsoleMsg = false,
                consoleMsgsLoading = false,
                consoleMsgs = [] as Array<ConsoleRow>,  
                _logBookLoaded = false,
                logBookItems = [] as Array<AloLogbookItem>,                
                infosPanelVisible = false,                
                missionMapVisibility = {},                                  
                missionDetailVisibility = {},
                selectedMissionPlanMissionId = -1
            } = {}) {  
        this.typeUiid = typeUiid
        this.timelineIndex = timelineIndex
        this.rangeTimelineIndex = rangeTimelineIndex
        this.sciHoverData = sciHoverData        
        this.navHoverData = navHoverData        
        this.mapStyles = mapStyles
        this.consoleMsgsLoading = consoleMsgsLoading
        this.canLogConsoleMsg = canLogConsoleMsg
        this._logBookLoaded = _logBookLoaded
        this.logBookItems = logBookItems
        this.consoleMsgs = consoleMsgs
        this.infosPanelVisible = infosPanelVisible
        this.missionMapVisibility = missionMapVisibility        
        this.missionDetailVisibility = missionDetailVisibility    
        this.selectedMissionPlanMissionId = selectedMissionPlanMissionId    
    }
} 

export const buildFleetUIStateId = (fleId:number,typeuiid:string) => {
    return `fleet_${fleId}_${typeuiid}`
}